export default __webpack_public_path__ + "static/media/Lookout.6fe1c661.jpg";